module.exports = __webpack_public_path__ + "static/media/16-10.d7953270.mp3";